import React from 'react';
import { Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { ComponentDesign } from '@paragon/contract-library';

export function ComponentDesignMenu(props: {
  readonly context: 'station' | 'assembly group';
  readonly componentDesign: ComponentDesign;

  readonly anchor: MenuAnchor;
  readonly onClose: () => void;
  readonly onRemoveComponentDesign: () => void;
}) {
  return (
    <Menu open={props.anchor != null} {...getAnchorProps(props.anchor)} onClose={props.onClose}>
      <MenuItem
        onClick={() => {
          props.onClose();
          props.onRemoveComponentDesign();
        }}
      >
        Remove from {props.context}
      </MenuItem>
    </Menu>
  );
}
